import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../../styles/Blogs/SwiperSlider.scss";
import arrowIcon from "../../assets/images/blogArrowIcon.png";

// import required modules
import { Pagination, Navigation } from "swiper";

import { Col, Container, Row } from "react-bootstrap";
import { BiTimeFive } from "react-icons/bi";
import { AiOutlineEye } from "react-icons/ai";
import articlesImage from "../../assets/images/popular-articles-image.png";
import articlesPersonImage from "../../assets/images/articles-person-image.png";
const SwiperSlider = () => {
  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <Container className="blog-articles-container px-5 py-5">
            <div className="blog-articles-section">
              <img src={arrowIcon} alt="" />
              <h1 className="popular-articles">Popular Articles</h1>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <Container className="blog-articles-container px-5 py-5">
            <div className="blog-articles-section">
              {/* <div className="arrow-icons">
                <BsArrowDownRight />
              </div> */}
              <img src={arrowIcon} alt="" />
              <h1 className="popular-articles">Popular Articles</h1>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <Container className="blog-articles-container px-5 py-5">
            <div className="blog-articles-section">
              {/* <div className="arrow-icons">
                <BsArrowDownRight />
              </div> */}
              <img src={arrowIcon} alt="" />
              <h1 className="popular-articles">Popular Articles</h1>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <div className="blog-articles-items">
              <Row>
                <Col md={4}>
                  <img
                    src={articlesImage}
                    alt="articleImage"
                    className="img-fluid h-100"
                  />
                </Col>
                <Col md={8}>
                  <div className="article-creator mt-2 mt-sm-2 mt-md-0">
                    <img
                      src={articlesPersonImage}
                      alt="img"
                      className="article-creator-image"
                    />
                    <div className="article-creator-section">
                      <h3 className="article-creator-name">
                        Md. Shafiqur Rahman Refat
                      </h3>
                      <h3 className="blog-article-date">25 Sept,2022</h3>
                    </div>
                  </div>
                  <div className="articles-details">
                    <h2 className="blog-articles-title">
                      The Grid System: Importance of a Solid UX/UI Layout
                    </h2>
                    <p className="blog-articles-description">
                      UX/UI and graphic designers have many things in common.
                      Among them is the practice of using grid layouts to
                      structure their designs{" "}
                    </p>
                    <div className="time-and-view d-flex">
                      <div className="blog-items-reading-time">
                        <span className="time-and-view-color">
                          <BiTimeFive />
                        </span>{" "}
                        6 min
                      </div>
                      <div className="blog-items-view">
                        <span className="time-and-view-color">
                          <AiOutlineEye />
                        </span>{" "}
                        1234
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default SwiperSlider;
